import { Routes, Route, Navigate } from 'react-router-dom'
import ErrorBoundary from './components/ui/ErrorBoundary'
import { CompanyThemeProvider } from './components/providers/CompanyThemeProvider'
import { LandingPageGuard } from './components/guards/LandingPageGuard'
import { EarlySignalsGuard } from './apps/early-signals/EarlySignalsGuard'
import { RiskAlertFeedbackPage } from './apps/early-signals/RiskAlertFeedbackPage'
import { RiskIntakeDecisionPage } from './apps/early-signals/RiskIntakeDecisionPage'
import { SimpleHqGuard } from './apps/simple-hq/SimpleHqGuard'
import { LeaveEmailActionPage } from './apps/simple-hq/LeaveEmailActionPage'

function App() {
  return (
    <ErrorBoundary>
      <CompanyThemeProvider>
        <Routes>
          <Route path="/" element={<LandingPageGuard />} />
          <Route path="/risk-alert-feedback" element={<RiskAlertFeedbackPage />} />
          <Route path="/risk-intake-decision" element={<RiskIntakeDecisionPage />} />
          <Route path="/simple-hq-leave-action" element={<LeaveEmailActionPage />} />
          <Route path="/early-signals/*" element={<EarlySignalsGuard />} />
          <Route path="/simple-hq/*" element={<SimpleHqGuard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </CompanyThemeProvider>
    </ErrorBoundary>
  )
}

export default App
